import { Table } from '@tanstack/react-table'
import clsx from 'clsx'

import TableHeaderComponent from '../TableHeaderComponent'

type TableHeaderComponentProps<T> = {
  table: Table<T>
  disableHeader: boolean
  hideHeader: boolean
  manualPagination: boolean
  numResults: number
  hideCount: boolean
  allowDragDropSort: boolean
  stickyHeader: boolean
  enableResizing: boolean
}

const TableHeadersComponent = <T extends unknown>({
  table,
  disableHeader,
  hideHeader,
  stickyHeader,
  manualPagination,
  numResults,
  hideCount,
  allowDragDropSort,
  enableResizing
}: TableHeaderComponentProps<T>) => {
  if (disableHeader) {
    return null
  }

  if (hideHeader) {
    return (
      <div className='thead'>
        <div className='table-row' />
      </div>
    )
  }

  return (
    <thead className={clsx('thead', stickyHeader && 'sticky-thead')}>
      {table.getHeaderGroups().map(headerGroup => (
        <tr key={headerGroup.id} className='table-row'>
          {headerGroup.headers.map((header, i) => (
            <TableHeaderComponent
              key={`${header.id}-${i}`}
              table={table}
              header={header}
              manualPagination={manualPagination}
              numResults={numResults}
              hideCount={hideCount}
              allowDragDropSort={allowDragDropSort}
              enableResizing={enableResizing}
              i={i}
            />
          ))}
        </tr>
      ))}
    </thead>
  )
}

export default TableHeadersComponent
